<template>
  <div>
    <div class="section-base__title-box">
      <div class="section-base__title">
        {{ title }}
      </div>
    </div>

    <v-stepper :value="currentStep" class="steppers-base">
      <div class="stepper-header-wrap">
        <v-stepper-header>
          <template v-for="n in stepsCount">
            <v-stepper-step
              :key="`step${n}`"
              :step="n"
              :complete="currentStep > n"
            >
              Шаг {{ n }}
            </v-stepper-step>
            <v-divider :key="`divider${n}`" v-if="n < stepsCount" />
          </template>
        </v-stepper-header>
      </div>
    </v-stepper>
  </div>
</template>

<script>
export default {
  name: 'AddStatementHeader',
  props: {
    title: {
      type: String,
      required: true,
    },
    currentStep: {
      type: Number,
      required: true,
    },
    stepsCount: {
      type: Number,
      required: true,
    },
  },
};
</script>

<style scoped lang="scss">
.stepper-header-wrap {
  width: 30%;
}
</style>
